import { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TabsPropsExtend, AdminTabType } from './types/propTypes';
import styles from './AdminTab.module.scss';

export const AdminTab: FC<TabsPropsExtend> = (props: TabsPropsExtend) => {
  const { tabList, onTabClick, selectedTab: selectedTabProp } = props;

  // Provide a default value for selectedTab if it's not provided
  const selectedTab = selectedTabProp?.toString() || (tabList.length > 0 ? tabList[0].id : null);

  const [activeTab, setActiveTab] = useState<string | null>(selectedTab);
  const [tabIndex, setTabIndex] = useState<number | null>(null);
  const { t } = useTranslation();
  const label = t('admin.tab.tabButton');

  useEffect(() => {
    // Find the index of the selectedTab
    const selectedIndex = tabList.findIndex((tab) => tab.id === selectedTab);

    // Update activeTab and tabIndex based on the selectedTab
    setActiveTab(selectedTab as string);
    setTabIndex(selectedIndex);
  }, [selectedTab, tabList]);

  const handleTabClick = (key: string, index: number) => {
    setActiveTab(key);
    setTabIndex(index);
    if (onTabClick) {
      onTabClick(key, index);
    }
  };

  return (
    <div className={styles['admin-tab-container']} data-testid="admin-tab-container">
      {tabList.map((tab, index) => (
        <div className={styles['admin-tab-content']} key={tab.title}>
          <div
            role="button"
            aria-labelledby={label}
            className={`${styles['admin-tab-title']} ${tab.id === activeTab ? styles['active-tab'] : ''} ${
              tabList.length > 1 ? styles['admin-cursor-pointer'] : ''
            }`}
            onClick={() => handleTabClick(tab.id, index)}
            onKeyDown={() => handleTabClick(tab.id, index)}
            tabIndex={tabIndex === index ? 0 : -1} // Set tabIndex based on the current tab's index
          >
            {tab.title}
          </div>
          <div className={styles['admin-tab-value']}>{'value' in tab ? tab.value : ''}</div>
          {index !== tabList.length - 1 && <div className={styles['vertical-line']} />}
        </div>
      ))}
    </div>
  );
};

export default AdminTab;
export type { AdminTabType };
